export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readTime: number;
  tags: string[];
  viewCount: number;
  likeCount: number;
  commentCount: number;
  isFeatured: boolean;
  isHot: boolean;
}

export const articles: Article[] = [
  {
    id: '1',
    title: 'React 19 新特性全面解析：从 Server Components 到 Actions',
    excerpt: 'React 19 带来了诸多革命性的新特性，包括 Server Components 的稳定版本、全新的 Actions API、改进的 Hooks 以及更好的 Suspense 支持。本文将带你深入探索这些变化。',
    content: `<h2>引言</h2><p>React 19 是 React 框架发展历程中的一个重要里程碑。这个版本不仅稳定了期待已久的 Server Components，还引入了 Actions、use() hook、以及诸多性能优化。本文将全面解析 React 19 的核心新特性。</p><h2>Server Components 正式稳定</h2><p>Server Components 允许组件在服务端渲染，大幅减少了客户端 JavaScript 打包体积。在 React 19 中，Server Components 已成为一等公民，与 Client Components 可以无缝配合使用。</p><p>Server Components 特别适合用于数据获取和渲染静态内容，而 Client Components 则处理交互逻辑。这种分工模式使得应用的整体性能得到了显著提升。</p><h2>全新的 Actions API</h2><p>React 19 引入了 Actions 的概念，包括 <code>useActionState</code>、<code>useFormStatus</code> 和 <code>useOptimistic</code> 等新的 Hook。这些 API 简化了表单处理和数据变更的流程。</p><h2>新的 use() Hook</h2><p><code>use()</code> 是一个全新的 Hook，可以在渲染期间读取 Promise 和 Context 的值。与传统的 <code>useEffect</code> + <code>useState</code> 模式相比，它的代码更加简洁直观。</p><h2>改进的 Suspense</h2><p>React 19 对 Suspense 进行了重要改进，使其在处理异步边界时更加灵活。现在可以在更多的场景中使用 Suspense 来优化用户体验。</p><h2>总结</h2><p>React 19 是一个充满创新与突破的版本，它将前端开发的范式推向了新的高度。对于前端开发者来说，掌握这些新特性将成为保持竞争力的关键。</p>`,
    category: 'frontend',
    author: '张三',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20programmer%20portrait%20professional%20headshot%20warm%20lighting%20simple%20clean%20background%20friendly%20smile&width=80&height=80&seq=avatar-zs&orientation=squarish',
    publishDate: '2026-08-02',
    readTime: 12,
    tags: ['React', '前端框架', 'JavaScript'],
    viewCount: 15320,
    likeCount: 892,
    commentCount: 156,
    isFeatured: true,
    isHot: true,
  },
  {
    id: '2',
    title: 'Go 语言并发编程实战：从 Goroutine 到 Channel 的深度剖析',
    excerpt: 'Go 语言以其轻量级的并发模型而闻名。本文将从 Goroutine 的底层原理出发，深入讲解 Channel 的使用技巧、并发模式以及常见陷阱，帮助你写出高效可靠的并发代码。',
    content: `<h2>为什么选择 Go 进行并发编程</h2><p>Go 语言的并发模型基于 CSP（Communicating Sequential Processes）理论，通过 Goroutine 和 Channel 提供了简洁而强大的并发编程能力。</p><h2>Goroutine 内部原理</h2><p>Goroutine 是 Go 运行时管理的轻量级线程，初始栈大小仅为 2KB，创建和切换的开销极低。这使得在一个程序中同时运行成千上万个 Goroutine 成为可能。</p><h2>Channel 深入解析</h2><p>Channel 是 Goroutine 之间通信的管道。Go 提供了有缓冲和无缓冲两种 Channel，以及单向 Channel 来增强类型安全性。</p><h2>常见并发模式</h2><p>包括 Pipeline 模式、Fan-out/Fan-in 模式、Or-Done 模式等，这些模式在实际项目中非常实用。</p><h2>并发陷阱与最佳实践</h2><p>避免 Goroutine 泄漏、正确处理 Channel 关闭、使用 context 控制超时与取消，这些都是并发编程中必须注意的问题。</p>`,
    category: 'backend',
    author: '李四',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20engineer%20portrait%20professional%20headshot%20warm%20light%20clean%20simple%20background%20confident&width=80&height=80&seq=avatar-ls&orientation=squarish',
    publishDate: '2026-08-01',
    readTime: 15,
    tags: ['Go', '并发编程', '后端开发'],
    viewCount: 12890,
    likeCount: 756,
    commentCount: 132,
    isFeatured: true,
    isHot: true,
  },
  {
    id: '3',
    title: '大语言模型应用实战：使用 LangChain 构建智能问答系统',
    excerpt: '随着 GPT-4 和 Claude 等大语言模型的成熟，基于 LLM 的应用开发变得越来越热门。本文将使用 LangChain 框架，从零开始构建一个智能文档问答系统。',
    content: `<h2>大语言模型时代的到来</h2><p>2024年以来，大语言模型的能力不断提升，从简单的文本生成发展到复杂的推理、代码编写和多模态理解。如何在实际业务中落地 LLM 成为开发者关注的焦点。</p><h2>LangChain 框架介绍</h2><p>LangChain 是一个用于构建 LLM 应用的框架，它提供了 Chains、Agents、Memory 等核心抽象，大大简化了 LLM 应用的开发流程。</p><h2>构建 RAG 问答系统</h2><p>RAG（Retrieval-Augmented Generation）是当前最流行的 LLM 应用模式。我们将使用 LangChain 结合向量数据库来实现一个高效的文档问答系统。</p><h2>优化与部署</h2><p>讨论了提示词优化、检索质量提升、流式响应实现等实际部署中的关键问题。</p>`,
    category: 'ai',
    author: '王五',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20researcher%20portrait%20professional%20headshot%20warm%20lighting%20simple%20background&width=80&height=80&seq=avatar-ww&orientation=squarish',
    publishDate: '2026-07-30',
    readTime: 18,
    tags: ['AI', 'LLM', 'LangChain', 'RAG'],
    viewCount: 23450,
    likeCount: 1234,
    commentCount: 289,
    isFeatured: true,
    isHot: true,
  },
  {
    id: '4',
    title: 'Rust 入门指南：所有权系统与生命周期精讲',
    excerpt: 'Rust 的所有权系统是其最核心也最具挑战性的特性。本文将通过大量实例，帮助你理解所有权、借用和生命周期的核心概念，轻松跨越 Rust 学习的第一道门槛。',
    content: `<h2>为什么 Rust 需要所有权系统</h2><p>Rust 的所有权系统是其内存安全保证的基石。在没有垃圾回收器的情况下，Rust 通过编译时的所有权检查来确保内存安全，避免了空指针、悬垂指针等常见问题。</p><h2>所有权规则</h2><p>Rust 的所有权遵循三条核心规则：每个值有且只有一个所有者、值在任一时刻只能有一个可变引用或多个不可变引用、引用必须始终有效。</p><h2>借用与引用</h2><p>借用允许你在不获取所有权的情况下使用值。可变借用和不可变借用有不同的规则和限制。</p><h2>生命周期注解</h2><p>生命周期是 Rust 编译器用来确保引用始终有效的机制。理解生命周期注解是掌握 Rust 的关键一步。</p>`,
    category: 'language',
    author: '赵六',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20female%20programmer%20portrait%20professional%20headshot%20warm%20lighting%20simple%20clean%20background&width=80&height=80&seq=avatar-zl&orientation=squarish',
    publishDate: '2026-07-28',
    readTime: 20,
    tags: ['Rust', '系统编程', '内存安全'],
    viewCount: 9870,
    likeCount: 567,
    commentCount: 98,
    isFeatured: true,
    isHot: false,
  },
  {
    id: '5',
    title: 'Flutter 3.x 跨平台开发最佳实践：一套代码覆盖六大平台',
    excerpt: 'Flutter 3.x 已经支持 iOS、Android、Web、Windows、macOS 和 Linux 六大平台。本文将分享在实际项目中实现高效跨平台开发的最佳实践和避坑指南。',
    content: `<h2>Flutter 跨平台能力概述</h2><p>Flutter 使用自绘引擎 Skia，通过 Dart 语言编写一套代码即可运行在多个平台上。Flutter 3.x 进一步增强了各平台的适配能力。</p><h2>平台适配策略</h2><p>讨论了如何使用 Platform Channel 访问原生功能、如何根据平台调整 UI 样式、以及如何处理各平台的差异化需求。</p><h2>性能优化技巧</h2><p>包括减少不必要的重建、使用 const 构造函数、图片缓存优化、列表性能优化等实用技巧。</p>`,
    category: 'mobile',
    author: '张三',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20developer%20portrait%20professional%20headshot%20warm%20lighting%20simple%20background%20casual&width=80&height=80&seq=avatar-zs2&orientation=squarish',
    publishDate: '2026-07-25',
    readTime: 14,
    tags: ['Flutter', '跨平台', '移动开发'],
    viewCount: 7650,
    likeCount: 423,
    commentCount: 67,
    isFeatured: false,
    isHot: true,
  },
  {
    id: '6',
    title: 'Kubernetes 生产环境运维实战：从集群搭建到监控告警',
    excerpt: '本文详细介绍 Kubernetes 在生产环境中的完整运维方案，涵盖集群高可用架构设计、资源管理、安全加固、日志收集和监控告警体系的搭建。',
    content: `<h2>Kubernetes 集群架构设计</h2><p>生产环境中的 Kubernetes 集群需要考虑高可用、灾备、网络规划等多个方面。本文将分享一套经过验证的集群架构方案。</p><h2>资源管理与优化</h2><p>合理设置 Resource Quota、LimitRange，使用 HPA/VPA 实现自动扩缩容，是保证集群稳定运行的关键。</p><h2>监控告警体系</h2><p>基于 Prometheus + Grafana + AlertManager 搭建完整的监控告警体系，实现对集群、节点、应用的全面监控。</p>`,
    category: 'devops',
    author: '李四',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20engineer%20portrait%20professional%20headshot%20warm%20light%20clean%20simple%20background%20serious&width=80&height=80&seq=avatar-ls2&orientation=squarish',
    publishDate: '2026-07-22',
    readTime: 22,
    tags: ['Kubernetes', 'DevOps', '运维'],
    viewCount: 11230,
    likeCount: 678,
    commentCount: 145,
    isFeatured: false,
    isHot: true,
  },
  {
    id: '7',
    title: 'PostgreSQL 性能调优完全指南：索引优化与查询计划分析',
    excerpt: '数据库性能是后端系统的核心关注点。本文全面讲解 PostgreSQL 的索引策略、查询计划分析工具和常见的性能优化手段。',
    content: `<h2>理解 PostgreSQL 查询计划</h2><p>EXPLAIN 和 EXPLAIN ANALYZE 是 PostgreSQL 中最强大的性能分析工具。学会阅读查询计划是性能优化的第一步。</p><h2>索引策略</h2><p>B-Tree、Hash、GiST、GIN、BRIN 等索引类型各有适用场景。选择合适的索引类型和组合可以带来数量级的性能提升。</p><h2>常见性能问题与解决方案</h2><p>慢查询优化、连接池配置、VACUUM 策略、分区表设计等实际问题的解决方案。</p>`,
    category: 'database',
    author: '王五',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20female%20engineer%20portrait%20professional%20headshot%20warm%20lighting%20simple%20background%20friendly&width=80&height=80&seq=avatar-ww2&orientation=squarish',
    publishDate: '2026-07-20',
    readTime: 16,
    tags: ['PostgreSQL', '数据库', '性能优化'],
    viewCount: 8920,
    likeCount: 534,
    commentCount: 89,
    isFeatured: true,
    isHot: false,
  },
  {
    id: '8',
    title: '2026 年值得关注的十大开源项目',
    excerpt: '开源社区持续繁荣发展，每年都有令人眼前一亮的新项目涌现。本文精选了 2026 年最值得开发者关注的十个开源项目，涵盖前端、后端、AI 等多个领域。',
    content: `<h2>开源生态持续繁荣</h2><p>2026年，开源社区继续保持高速发展态势。从基础工具到 AI 应用，各类优秀的开源项目层出不穷。</p><h2>十大精选项目</h2><p>本文详细介绍了包括 Bun、Biome、Turso、Hono、Drizzle ORM 等在内的十个优秀开源项目，分析它们的技术特点和适用场景。</p>`,
    category: 'opensource',
    author: '赵六',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20programmer%20portrait%20professional%20headshot%20warm%20lighting%20simple%20clean%20background&width=80&height=80&seq=avatar-zl2&orientation=squarish',
    publishDate: '2026-07-18',
    readTime: 10,
    tags: ['开源', 'GitHub', '工具推荐'],
    viewCount: 18920,
    likeCount: 1023,
    commentCount: 234,
    isFeatured: false,
    isHot: true,
  },
  {
    id: '9',
    title: 'TypeScript 5.x 类型体操：高级类型与模式匹配深度解析',
    excerpt: 'TypeScript 的类型系统图灵完备，可以进行复杂的类型编程。本文深入探讨条件类型、模板字面量类型、映射类型等高级特性。',
    content: `<h2>TypeScript 类型系统的强大之处</h2><p>TypeScript 的类型系统不仅仅是简单的类型注解，它支持条件类型、递归类型、模板字面量类型等高级特性，可以实现图灵完备的类型编程。</p><h2>条件类型深入</h2><p>条件类型允许根据类型关系进行分支判断，结合 infer 关键字可以实现模式匹配和类型提取。</p><h2>实际应用场景</h2><p>从深层 Partial、字符串解析器到类型安全的 API 客户端，展示类型编程在实际项目中的应用。</p>`,
    category: 'language',
    author: '张三',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20developer%20portrait%20professional%20headshot%20warm%20lighting%20simple%20background%20thoughtful&width=80&height=80&seq=avatar-zs3&orientation=squarish',
    publishDate: '2026-07-15',
    readTime: 19,
    tags: ['TypeScript', '类型系统', '前端'],
    viewCount: 13450,
    likeCount: 789,
    commentCount: 167,
    isFeatured: false,
    isHot: false,
  },
  {
    id: '10',
    title: '微服务架构设计模式：从单体到分布式的演进之路',
    excerpt: '微服务架构在带来灵活性的同时也引入了复杂性。本文梳理了微服务架构中的核心设计模式，包括服务拆分、通信、数据管理和可观测性。',
    content: `<h2>微服务架构的利与弊</h2><p>微服务架构能够带来独立部署、技术异构、团队自治等优势，但也引入了分布式系统的复杂性。是否采用微服务需要根据实际情况权衡。</p><h2>核心设计模式</h2><p>包括 API Gateway、服务发现、熔断器、CQRS、事件溯源、Saga 等模式的详细介绍和适用场景。</p><h2>从单体到微服务的迁移策略</h2><p>逐步拆分、Strangler Fig 模式、功能开关等渐进式迁移策略的实操指南。</p>`,
    category: 'backend',
    author: '李四',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20architect%20portrait%20professional%20headshot%20warm%20lighting%20simple%20background&width=80&height=80&seq=avatar-ls3&orientation=squarish',
    publishDate: '2026-07-12',
    readTime: 17,
    tags: ['微服务', '架构', '后端'],
    viewCount: 10230,
    likeCount: 612,
    commentCount: 123,
    isFeatured: false,
    isHot: false,
  },
  {
    id: '11',
    title: 'AI 辅助编程的现在与未来：Copilot 与 Cursor 深度体验对比',
    excerpt: 'AI 编程助手正在改变开发者的工作方式。本文深度对比了 GitHub Copilot 和 Cursor 两款主流 AI 编程工具的实际使用体验和适用场景。',
    content: `<h2>AI 编程工具的崛起</h2><p>从代码补全到完整功能生成，AI 编程助手的能力在过去一年中有了质的飞跃。GitHub Copilot 和 Cursor 是其中的佼佼者。</p><h2>功能对比</h2><p>从代码补全、代码生成、代码解释、Bug 修复、测试生成等多个维度对比两款工具的实际表现。</p><h2>最佳实践</h2><p>如何利用 AI 工具提高开发效率，同时保持代码质量和安全性的建议。</p>`,
    category: 'ai',
    author: '王五',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20researcher%20portrait%20professional%20headshot%20warm%20lighting%20simple%20background%20smiling&width=80&height=80&seq=avatar-ww3&orientation=squarish',
    publishDate: '2026-07-10',
    readTime: 11,
    tags: ['AI', '开发工具', 'Copilot'],
    viewCount: 28760,
    likeCount: 1567,
    commentCount: 345,
    isFeatured: true,
    isHot: true,
  },
  {
    id: '12',
    title: 'CSS Container Queries 实战：真正的组件级响应式设计',
    excerpt: 'Container Queries 让组件可以根据父容器的大小而非视口大小进行样式调整，彻底改变了响应式设计的范式。',
    content: `<h2>从 Media Queries 到 Container Queries</h2><p>传统的 Media Queries 只能基于视口大小进行响应式设计，而 Container Queries 允许组件根据自身容器的大小进行样式调整。</p><h2>基本用法</h2><p>通过 container-type 和 @container 规则，可以轻松实现组件级的响应式设计。</p><h2>实际应用案例</h2><p>展示卡片组件、布局组件、导航组件等在 Container Queries 下的实现方式。</p>`,
    category: 'frontend',
    author: '赵六',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20female%20designer%20portrait%20professional%20headshot%20warm%20lighting%20simple%20clean%20background&width=80&height=80&seq=avatar-zl3&orientation=squarish',
    publishDate: '2026-07-08',
    readTime: 9,
    tags: ['CSS', '响应式设计', '前端'],
    viewCount: 6540,
    likeCount: 389,
    commentCount: 56,
    isFeatured: false,
    isHot: false,
  },
  {
    id: '13',
    title: 'iOS 18 开发新特性：SwiftUI 进阶与 SwiftData 实战',
    excerpt: 'iOS 18 带来了 SwiftUI 和 SwiftData 的重大更新。本文将介绍新版本的亮点特性以及在实际项目中的应用技巧。',
    content: `<h2>iOS 18 开发者新特性总览</h2><p>iOS 18 为开发者带来了诸多新能力，SwiftUI 的 API 更加丰富，SwiftData 也更加成熟稳定。</p><h2>SwiftUI 新特性</h2><p>包括新的导航 API、自定义容器、改进的动画系统等。这些新特性让 SwiftUI 的开发体验更加流畅。</p><h2>SwiftData 实战</h2><p>SwiftData 提供了声明式的数据持久化方案，结合 SwiftUI 可以实现高效的本地数据管理。</p>`,
    category: 'mobile',
    author: '张三',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20iOS%20developer%20portrait%20professional%20headshot%20warm%20lighting%20simple%20background&width=80&height=80&seq=avatar-zs4&orientation=squarish',
    publishDate: '2026-07-05',
    readTime: 13,
    tags: ['iOS', 'SwiftUI', '移动开发'],
    viewCount: 5430,
    likeCount: 312,
    commentCount: 45,
    isFeatured: false,
    isHot: false,
  },
  {
    id: '14',
    title: 'Redis 高级应用：缓存策略与分布式锁的最佳实践',
    excerpt: 'Redis 不仅是缓存工具，更是构建高性能分布式系统的利器。本文深入讲解缓存策略选择和分布式锁的正确实现方式。',
    content: `<h2>Redis 的多面手角色</h2><p>Redis 在缓存、消息队列、分布式锁、计数器、排行榜等多个场景中都能发挥重要作用。</p><h2>缓存策略选择</h2><p>Cache Aside、Read/Write Through、Write Behind 等策略的对比分析，以及缓存穿透、击穿、雪崩的解决方案。</p><h2>分布式锁实现</h2><p>基于 Redlock 算法的分布式锁实现，以及使用 Redisson 简化开发的实践。</p>`,
    category: 'database',
    author: '李四',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20backend%20engineer%20portrait%20professional%20headshot%20warm%20lighting%20simple%20background&width=80&height=80&seq=avatar-ls4&orientation=squarish',
    publishDate: '2026-07-02',
    readTime: 14,
    tags: ['Redis', '缓存', '分布式系统'],
    viewCount: 8760,
    likeCount: 498,
    commentCount: 78,
    isFeatured: false,
    isHot: false,
  },
  {
    id: '15',
    title: 'Docker Compose 编排实战：本地开发环境一键搭建',
    excerpt: '使用 Docker Compose 可以快速搭建包含数据库、缓存、消息队列等服务的完整本地开发环境，告别环境配置的烦恼。',
    content: `<h2>为什么需要 Docker Compose</h2><p>现代应用通常依赖多个服务，手动配置这些服务费时费力且容易出错。Docker Compose 提供了一站式的解决方案。</p><h2>典型开发环境搭建</h2><p>以 Node.js + PostgreSQL + Redis + RabbitMQ 为例，展示完整的 docker-compose.yml 配置。</p><h2>最佳实践</h2><p>健康检查配置、数据持久化、网络隔离、环境变量管理等最佳实践。</p>`,
    category: 'devops',
    author: '王五',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20devops%20engineer%20portrait%20professional%20headshot%20warm%20lighting%20simple%20background&width=80&height=80&seq=avatar-ww4&orientation=squarish',
    publishDate: '2026-06-28',
    readTime: 11,
    tags: ['Docker', 'DevOps', '开发环境'],
    viewCount: 7890,
    likeCount: 445,
    commentCount: 67,
    isFeatured: false,
    isHot: false,
  },
  {
    id: '16',
    title: 'WebAssembly 全栈应用开发：用 Rust 构建高性能 Web 应用',
    excerpt: 'WebAssembly 正在改变 Web 开发的格局。本文探索使用 Rust + WebAssembly 构建高性能前端应用和边缘计算服务的完整方案。',
    content: `<h2>WebAssembly 的现状与未来</h2><p>WebAssembly 已经从实验性技术发展为成熟的 Web 标准，被广泛应用于高性能计算、游戏引擎、图像处理等领域。</p><h2>Rust + Wasm 开发实践</h2><p>使用 wasm-pack 将 Rust 代码编译为 WebAssembly，并结合 Web Worker 实现高性能计算。</p><h2>边缘计算应用</h2><p>介绍了 WasmEdge 等 WebAssembly 运行时在边缘计算场景中的应用。</p>`,
    category: 'frontend',
    author: '赵六',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20engineer%20portrait%20professional%20headshot%20warm%20lighting%20simple%20clean%20background&width=80&height=80&seq=avatar-zl4&orientation=squarish',
    publishDate: '2026-06-25',
    readTime: 16,
    tags: ['WebAssembly', 'Rust', '前端'],
    viewCount: 6780,
    likeCount: 378,
    commentCount: 56,
    isFeatured: false,
    isHot: false,
  },
];

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getArticlesByCategory(category: string): Article[] {
  return articles.filter((a) => a.category === category);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.isFeatured);
}

export function getHotArticles(): Article[] {
  return articles.filter((a) => a.isHot);
}

export function getRecentArticles(limit: number = 6): Article[] {
  return [...articles].sort((a, b) => b.publishDate.localeCompare(a.publishDate)).slice(0, limit);
}